import {Locales} from '@netx/core-next/locales/utils/Locales';
import {AssetViewFields} from './schema';

export const AssetViewsTitle = Locales((i18n) => ({
	VIEWS: i18n('i18n.views'),
}));

export const AssetViewsSubTitle = Locales((i18n) => ({
	TOTAL: (count: number) => i18n('i18n.nItems', {count}),
}));

export const AssetViewManagerTitle = Locales((i18n) => ({
	CREATE: i18n('i18n.addView'),
	EDIT: i18n('i18n.editView'),
	REPLACE: i18n('i18n.replaceView'),
}));

export const AssetViewManagerActionLabel = Locales((i18n) => ({
	SUBMIT: i18n('i18n.save'),
	REPLACE: i18n('i18n.replace'),
	CREATE: i18n('i18n.add'),
}));

export const AssetViewFormFieldLabel = Locales((i18n) => ({
	DESCRIPTION: i18n('i18n.description'),
	NAME: i18n('i18n.name'),
}));

export const AssetViewTitle = Locales((i18n) => ({
	DELETE_CONFIRM: i18n('i18n.deleteViewConfirmTitle'),
}));

export const AssetViewMessage = Locales((i18n) => ({
	UPDATE_FAILED: i18n('i18n.errorRequestFailed'),
	DELETE_CONFIRM: (fileName: string, assetName: string) =>
		i18n('i18n.deleteViewConfirm', {fileName, assetName}),
}));

export const AssetViewsMessage = Locales((i18n) => ({
	UPDATING: i18n('i18n.assetViewProcessing'),
	UPDATED: i18n('i18n.assetViewSuccessfullyUpdated'),
	CREATED: i18n('i18n.assetViewSuccessfullyCreated'),
	ERROR: i18n('i18n.errorRequestFailed'),
	NO_RECORDS: i18n('i18n.noViewsYet'),
	NO_MATCHING_RECORDS: i18n('i18n.noMatches'),
}));

export const AssetViewActionLabel = Locales((i18n) => ({
	CREATE: i18n('i18n.addView'),
	EDIT: i18n('i18n.edit'),
	DELETE: i18n('i18n.delete'),
	DOWNLOAD: i18n('i18n.download'),
}));

export const AssetViewsColumnLabel = Locales((i18n) => ({
	[AssetViewFields.name]: i18n('i18n.name'),
	[AssetViewFields.description]: i18n('i18n.description'),
	[AssetViewFields.fileTypeLabel]: i18n('i18n.fileType'),
	[AssetViewFields.fileSize]: i18n('i18n.fileSize'),
	dimensions: i18n('i18n.dimensions'),
	[AssetViewFields.creationDate]: i18n('i18n.creationDate'),
}));
